"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_FORMATS = void 0;
/**
 * Standard date/time format strings used throughout the application
 * Use these constants instead of hardcoded format strings for consistency
 *
 * Usage:
 *   import { DATE_FORMATS } from '@callmart/types';
 *   dayjs().format(DATE_FORMATS.DATETIME);
 */
exports.DATE_FORMATS = {
    // ISO formats (for API, database, comparisons)
    ISO8601: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]', // ISO 8601 format (2025-12-15T22:00:00.000Z) - use dayjs().utc().format() or .toISOString()
    ISO_DATETIME: 'YYYY-MM-DD HH:mm:ss', // Full datetime with seconds
    ISO_DATE: 'YYYY-MM-DD', // Date only, ISO format
    YEAR_MONTH: 'YYYY-MM', // Year and month for monthly grouping
    // App (German) formats (for user-facing display, Excel)
    DATE: 'DD.MM.YYYY', // German date format (day.month.year)
    DATETIME: 'DD.MM.YYYY HH:mm:ss', // German datetime with seconds
    DATETIME_DISPLAY: 'DD.MM.YYYY HH:mm', // German datetime without seconds (for general display)
    DATETIME_DASHED: 'DD.MM.YYYY - HH:mm', // For "last upload" displays
    DATE_TIME_SHORT: 'DD.MM - HH:mm', // Short German date-time (e.g., history popovers)
    MONTH_YEAR: 'MM.YYYY', // German month.year format (e.g., "06.2024")
    FIRST_OF_MONTH: '01.MM.YYYY', // First day of month in German format
    MONTH_YEAR_UNDERSCORE: 'MM_YYYY', // Month_Year for filenames (e.g., "06_2024")
    // Time formats
    TIME: 'HH:mm', // Time without seconds (slot times)
    TIME_WITH_SECONDS: 'HH:mm:ss', // Time with seconds
    // Display formats
    MONTH_NAME_YEAR: 'MMMM YYYY', // Full month name + year (e.g., "Januar 2025")
    MONTH_NAME: 'MMMM', // Full month name only (e.g., "Januar")
    MONTH_SHORT_YEAR: 'MMM YYYY', // Short month + year (e.g., "Jan 2025")
    MONTH_SHORT: 'MMM', // Short month name only (e.g., "Jan")
    WEEKDAY: 'dddd', // Full weekday name
    WEEKDAY_SHORT: 'ddd', // Short weekday name (e.g., "Mon")
    // Component formats (for grid columns, parsing)
    DAY_ONLY: 'DD', // Day number only (01-31)
    DAY_MONTH: 'DD.MM', // German day.month without year
    DAY_MONTH_HYPHEN: 'DD-MM', // Day-month with hyphen (for column IDs)
    // Alternative date formats
    DATE_HYPHEN: 'DD-MM-YYYY', // Date with hyphens (day-month-year)
    // Time component extraction
    HOUR_ONLY: 'HH', // Hour only (00-23)
    MINUTE_ONLY: 'mm', // Minute only (00-59)
    SECOND_ONLY: 'ss', // Second only (00-59)
    MILLISECOND_ONLY: 'ms', // Millisecond only (for duration calculations)
    // Year formats
    YEAR_TWO_DIGIT: 'YY', // 2-digit year (e.g., "25" for 2025)
    // Email and special formats
    EMAIL_HEADER: 'ddd, DD MMM YYYY HH:mm:ss [GMT]', // RFC 2822 email header date
    // File naming
    FILENAME_TIMESTAMP: 'YYYY-MM-DD_HH-mm-ss', // For Excel export filenames
};
